export default "__VITE_ASSET__dxnzspWw__"